import moment, { Moment } from 'moment';
import { Container, DayPill } from './DaySelector.styles';

export interface DaySelectorProps {
  availableDates: Array<string | Moment>;
  startDate: string | Moment;
  endDate: string | Moment;
  currentSelection?: string | Moment;
  onChange: (date: string) => void;
}

export const DaySelector = ({
  availableDates,
  startDate,
  endDate,
  currentSelection,
  onChange,
}: DaySelectorProps) => {
  const normalizedAvailableDates = availableDates.map((date) => moment(date).format('YYYY-MM-DD'));

  const start = moment(startDate);
  const end = moment(endDate);
  const daysInRange: Moment[] = [];

  for (let current = start.clone(); current.isSameOrBefore(end, 'day'); current.add(1, 'day')) {
    daysInRange.push(current.clone());
  }

  const handleDateClick = (date: Moment, isDisabled: boolean) => {
    if (isDisabled) return;

    const dateString = date.format('YYYY-MM-DD');
    onChange(dateString);
  };

  return (
    <Container>
      {daysInRange.map((date) => {
        const dateString = date.format('YYYY-MM-DD');
        const isAvailable = normalizedAvailableDates.includes(dateString);
        const isSelected = currentSelection
          ? dateString === moment(currentSelection).format('YYYY-MM-DD')
          : false;

        return (
          <DayPill
            key={dateString}
            type="button"
            isSelected={isSelected}
            isDisabled={!isAvailable}
            disabled={!isAvailable}
            onClick={() => handleDateClick(date, !isAvailable)}
            data-testid={`day-selector-day-${date.format('YYYY-MM-DD')}`}
          >
            <span className="day-number">{date.format('D')}</span>
            <span className="day-month">{date.format('MMM')}</span>
          </DayPill>
        );
      })}
    </Container>
  );
};
